import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        oldMenuList: [
            {
                menuId: '1',
                menuName: '订单管理',
                elicon: 'el-icon-s-order',
                mychecked: false,
                children: [
                    {
                        menuId: '11',
                        menuName: '订单',
                        component: '/orderMenu',
                        mychecked2: false,
                    },
                    // {
                    //     menuId: '12',
                    //     menuName: '订单设置',
                    //     component: '/orderSettings',
                    //     mychecked2: false,
                    // },
                    {
                        menuId: '13',
                        menuName: '退货及退款',
                        component: '/refundsMenu',
                        mychecked2: false,

                    },
                    {
                        menuId: '14',
                        menuName: '退货原因设置',
                        component: '/returnSetting',
                        mychecked2: false,

                    }
                ]
            },
            {
                menuId: '2',
                menuName: '需求单管理',
                elicon: 'el-icon-s-claim',
                mychecked: false,
                children: [
                    {
                        menuId: '21',
                        menuName: '定制需求单',
                        component: '/demandList',
                        mychecked2: false,

                    },
                ]
            },
            {
                menuId: '3',
                menuName: '商品管理',
                elicon: 'el-icon-s-goods',
                mychecked: false,
                children: [
                    {
                        menuId: '31',
                        menuName: '商品分类',
                        component: '/commodityClass',
                        mychecked2: false,

                    },
                    {
                        menuId: '32',
                        menuName: '商品列表',
                        component: '/commodityList',
                        mychecked2: false,

                    },
                    {
                        menuId: '33',
                        menuName: '运费设置',
                        component: '/freightSetting',
                        mychecked2: false,

                    },
                ]
            },
            {
                menuId: '4',
                menuName: '网站管理',
                elicon: 'el-icon-s-open',
                mychecked: false,
                children: [
                    {
                        menuId: '41',
                        menuName: '页面装修',
                        component: '/homeManage',
                        mychecked2: false,

                    },
                    {
                        menuId: '42',
                        menuName: 'banner管理',
                        component: '/bannerManage',
                        mychecked2: false,

                    },
                    {
                        menuId: '43',
                        menuName: '新闻管理',
                        component: '/newsSetting',
                        mychecked2: false,

                    },
                ]
            },

            {
                menuId: '5',
                menuName: '系统管理',
                elicon: 'el-icon-s-tools',
                mychecked: false,
                children: [
                    {
                        menuId: '51',
                        menuName: '客户管理',
                        component: '/usernamSetting',
                        mychecked2: false,

                    },
                    {
                        menuId: '52',
                        menuName: '员工管理',
                        component: '/accountSetting',
                        mychecked2: false,

                    },
                    {
                        menuId: '53',
                        menuName: '角色管理',
                        component: '/roleSetting',
                        mychecked2: false,

                    },
                ]
            }
        ],
        menuList: [],
        children: {},
    },
    // 获取状态
    getters: {
        getMenuList: state => {
            state.menuList = JSON.parse(sessionStorage.getItem("menuList") || '[]')
            return state.menuList
        },
        getActive: state => {
            state.children = JSON.parse(sessionStorage.getItem("children") || '{}')
            return state.children
        }
    },
    // 变更状态
    mutations: {
        setMenuList(state, menuList) {
            state.menuList = menuList
            sessionStorage.setItem("menuList", JSON.stringify(menuList));
        },
        setActive(state, children) {
            state.children = children
            sessionStorage.setItem("children", JSON.stringify(children));
        }
    },
})

export default store;